import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { HeadlineV1Attributes, HeadlineV1Meta } from '@/features/headline-v1/headline-v1-type';

import React from 'react';

import {
    useDynamicPageQueryData,
    useNavigationContextValue,
} from '@/core/features/a-dynamic-page/hooks/use-dynamic-page-query';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';
import HeadlineV1Default from '@/features/headline-v1/headline-v1-default';
import HeadlineV1Enumerated from '@/features/headline-v1/headline-v1-enumerated';
import HeadlineV1EnumeratedDesktop from '@/features/headline-v1/headline-v1-enumerated-desktop';

export type HeadlineV1Props = PageComponentProps<HeadlineV1Attributes, HeadlineV1Meta>;

export default function HeadlineV1({ attributes, meta }: HeadlineV1Props) {
    const { isNavigating, type: navigationType } = useNavigationContextValue();

    const dynamicPageLayoutId = useDynamicPageQueryData().data?.response.meta.layoutId ?? '';

    // Show loading state if it's a map update, and it's the headline-v1 on the search page
    const isLoading =
        dynamicPageLayoutId === 'Desktop_Map_Search_V1' &&
        meta.layoutPosition === 'header' &&
        navigationType === 'map_update' &&
        isNavigating;

    const { isDesktopView } = useDeviceoutput();

    if (attributes.enumerationNumber && isDesktopView) {
        return (
            <HeadlineV1EnumeratedDesktop
                {...attributes}
                isLoading={isLoading}
            />
        );
    }

    if (attributes.enumerationNumber && !isDesktopView) {
        return (
            <HeadlineV1Enumerated
                {...attributes}
                isLoading={isLoading}
            />
        );
    }

    return (
        <HeadlineV1Default
            {...attributes}
            isLoading={isLoading}
        />
    );
}
